import React, { useState } from 'react';
import PrimarySelect from '@mm/components/legacy-components/PrimarySelect/PrimarySelect';
import { ConnectionVariableModel } from '@mm/state/model/ConnectionVariableModel';
import AttributeModel from '@mm/state/model/AttributeModel';
import { Input } from '@mm/components';
import './VariableRow.pcss';
import { ArrowRightOutlined, DeleteOutlined } from '@ant-design/icons';

type Props = {
  variable: ConnectionVariableModel;
  options: AttributeModel[];
  selectedAttribute?: AttributeModel;
  onUpdate: (variable: ConnectionVariableModel) => void;
  onDelete: () => void;
  customOptionsPosition?: 'top' | 'bottom';
};

export const VariableRow = ({
  variable,
  options,
  onUpdate,
  onDelete,
  selectedAttribute,
  customOptionsPosition,
}: Props) => {
  const [variableReceivedAs, setVariableReceivedAs] = useState(
    variable.receivedAs,
  );

  const handleAttributeChange = (attribute: AttributeModel) => {
    const receivedAs = variableReceivedAs || attribute.name;
    const nextVariable = {
      ...variable,
      name: attribute.name,
      receivedAs,
    };

    setVariableReceivedAs(receivedAs);
    onUpdate(nextVariable);
  };

  const handleReceivedAsChange = () => {
    if (variableReceivedAs && selectedAttribute) {
      onUpdate({
        ...variable,
        receivedAs: variableReceivedAs,
      });
    }
  };

  return (
    <div className="connection-variable-row">
      <Input
        placeholder="Attribute Path"
        css={{ container: 'connection-variable-row__name-input' }}
        value={variableReceivedAs}
        onChange={e => setVariableReceivedAs(e.target.value)}
        onBlur={handleReceivedAsChange}
      />
      <ArrowRightOutlined className="connection-variable-row__arrow-icon" />
      <PrimarySelect
        className="connection-variable-row__primary-select"
        dropdownClassName="connection-variable-row__primary-select-dropdown"
        placeholder="Choose Value"
        onChange={handleAttributeChange}
        displayNameKey="friendlyName"
        options={options.map(v => ({
          ...v,
          friendlyName: v.friendlyName || v.name,
        }))}
        value={selectedAttribute}
        customDropdownStyles={{ zIndex: '1000003' }}
        customOptionsPosition={customOptionsPosition}
      />
      <DeleteOutlined
        className="connection-variable-row__trash-icon"
        onClick={onDelete}
      />
    </div>
  );
};
